export default "__VITE_ASSET__BRtw85Ci__"